module.exports = __webpack_public_path__ + "img/632.fffa7eb4.png";